function assertStateListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Network.addStateListener: listener must be a function");
  }
}
export {
  assertStateListener
};
//# sourceMappingURL=validate.js.map
